import { TFunction } from '@lyearn/i18n';
import { FunnelOutline, PeopleOutline, PlugOutline, TagOutline } from '@lyearn/icons';
import { TagsEntityConfig } from '@/components/FilterManager/configs/tags';
import { TagsQueryParams } from '@/components/FilterManager/configs/tags/types';
import { AcademyEntityConfig } from '@/components/FilterManager/EntityFilter/entity/academy';
import { CollectionEntityConfig } from '@/components/FilterManager/EntityFilter/entity/collection';
import { UserEntityConfig } from '@/components/FilterManager/EntityFilter/entity/user';
import { PillConfig } from '@/components/FilterManager/types';
import { NewFilterOption } from '@/components/FilterNew/types';
import EntityPill, {
  isEntityPillSelected,
} from '@/components/Filters/NestedFilter/NestedFilterPill/entities';
import TagsPills, {
  isTagPillSelected,
} from '@/components/Filters/NestedFilter/NestedFilterPill/tagFilters';
import { TagAvailableOnEnum } from '@/types/schema';

const TAG_ID = 'tagFilters';

export const getTagsConfig = (t: TFunction): NewFilterOption<TagsQueryParams> => ({
  value: TAG_ID,
  label: t('Common:Form.ContentTags'),
  Icon: TagOutline,
  configToRenderFilterBody: {
    id: TAG_ID,
    headerProps: {
      label: t('Common:Form.ContentTags'),
    },
    listConfig: TagsEntityConfig,
    queryParams: {
      availableOn: [TagAvailableOnEnum.Content],
    },
  },
});

export const getMoreFilterOptions = (t: TFunction): NewFilterOption[] => [
  {
    value: 'groupFilter',
    label: t('Common:Filter.Collection'),
    Icon: FunnelOutline,
    configToRenderFilterBody: {
      id: 'groupFilter',
      headerProps: {
        label: t('Common:Filter.Collection'),
      },
      listConfig: CollectionEntityConfig,
    },
  },
  {
    value: 'createdByIds',
    label: t('Common:Filter.CreatedBy'),
    Icon: PeopleOutline,
    configToRenderFilterBody: {
      id: 'createdByIds',
      headerProps: {
        label: t('Common:Filter.CreatedBy'),
      },
      listConfig: UserEntityConfig,
    },
  },
  {
    value: 'workspaceIds',
    label: t('Common:Filter.Academy'),
    Icon: PlugOutline,
    configToRenderFilterBody: {
      id: 'workspaceIds',
      headerProps: {
        label: t('Common:Filter.Academy'),
      },
      listConfig: AcademyEntityConfig,
    },
  },
  getTagsConfig(t),
];

export const pillsConfig = (t: TFunction): PillConfig[] => [
  {
    id: 'groupFilter',
    Component: (props) => {
      return (
        <EntityPill
          configToRenderFilterBody={getMoreFilterOptions(t)[0].configToRenderFilterBody}
          id="groupFilter"
          {...props}
        />
      );
    },
    isPillSelected: isEntityPillSelected,
  },
  {
    id: 'createdByIds',
    Component: (props) => {
      return (
        <EntityPill
          configToRenderFilterBody={getMoreFilterOptions(t)[1].configToRenderFilterBody}
          id="createdByIds"
          {...props}
        />
      );
    },
    isPillSelected: isEntityPillSelected,
  },
  {
    id: 'workspaceIds',
    Component: (props) => {
      return (
        <EntityPill
          configToRenderFilterBody={getMoreFilterOptions(t)[2].configToRenderFilterBody}
          id="workspaceIds"
          {...props}
        />
      );
    },
    isPillSelected: isEntityPillSelected,
  },
  {
    id: TAG_ID,
    Component: (props) => {
      return <TagsPills id={TAG_ID} {...props} />;
    },
    isPillSelected: isTagPillSelected,
  },
];
